module.exports = new __parcel__URL__("the-parent-trap.de7c7942.jpg").toString();